import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { addTransitionEndListener } from '@opten/transition/add-transition-end-listener';

export class TangramOptions {
	selectors: {
		sliderElement: string;
		sliderLinkElements: string;
	};
	classes: {
		active: string;
		transitionEnd: string;
	};
	speedAttribute: string;
	speed: number;
}

@Component({ className: 'js-tangram-container' })
export default class Tangram implements OnInit {
	private _countSliderElements: number = 0;
	private _currentSlide: number = 0;
	private _sliderElements: Array<Element>;
	private _sliderLinkElements: Array<Element>;
	private _svg: SVGElement;
	private _interval: number;
	private _options: TangramOptions = {
		selectors: {
			sliderElement: 'js-tangram__slide',
			sliderLinkElements: 'js-c-tangram__link'
		},
		classes: {
			active: '--active',
			transitionEnd: '--transition-end'
		},
		speedAttribute: 'data-slider-speed',
		speed: 5000
	};

	constructor(private _element: HTMLElement) {
		this._sliderElements = Array.from(
			_element.getElementsByClassName(
				this._options.selectors.sliderElement
			)
		);
		let dataSpeed = _element.getAttribute(this._options.speedAttribute);
		if (dataSpeed != null) {
			this._options.speed = parseInt(dataSpeed, 10);
		}
		this._svg = _element.getElementsByTagName('svg')[0] as SVGElement;
	}

	onInit() {
		if (this._sliderElements && this._sliderElements.length) {
			this._countSliderElements = this._sliderElements.length;
			this._sliderLinkElements = Array.from(this._svg.querySelectorAll(`.${this._options.selectors.sliderLinkElements}`));

			setTimeout(() => {
				this._svg.appendChild(this._sliderElements[this._currentSlide]);
				addClass(
					this._sliderElements[this._currentSlide],
					this._options.classes.active
				);
				addClass(
					this._sliderElements[this._currentSlide],
					this._options.classes.transitionEnd
				);
			}, 0);

			this._sliderLinkElements.forEach(link => {
				link.addEventListener('mouseover', () => {
					clearInterval(this._interval);
				});

				link.addEventListener('mouseleave', () => {
					this.start();
				});
			});
			this.start();
		}
	}

	start() {
		this._interval = setInterval(() => {
			this.changeSlide();
		}, this._options.speed);
	}

	changeSlide(): void {
		// hide current slide
		removeClass(
			this._sliderElements[this._currentSlide],
			this._options.classes.active
		);
		removeClass(
			this._sliderElements[this._currentSlide],
			this._options.classes.transitionEnd
		);

		// calculate new slide
		this._currentSlide++;

		if (this._currentSlide === this._countSliderElements) {
			this._currentSlide = 0;
		}

		// show new slide
		addClass(
			this._sliderElements[this._currentSlide],
			this._options.classes.active
		);

		addTransitionEndListener(this._sliderElements[this._currentSlide], () => {
			this._svg.appendChild(this._sliderElements[this._currentSlide]);
			addClass(this._sliderElements[this._currentSlide], this._options.classes.transitionEnd);
		}, 1000);
	}
}
